import script from "./WebServiceAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./WebServiceAdd.vue?vue&type=script&setup=true&lang=js"

import "./WebServiceAdd.vue?vue&type=style&index=0&id=5eabf47c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eabf47c"]])

export default __exports__